import { memo, useEffect } from 'react';
import { useTranslation } from '../i18n/TranslationProvider';

const RealDocumentTitle = ({ title }) => {
    useEffect(() => {
        const previousTitle = document.title;

        document.title = title;

        return () => {
            document.title = previousTitle;
        };
    }, [title]);

    return null;
};

const TranslatedWindowTitle = ({ titleKey }) => {
    const title = useTranslation(titleKey);

    return <RealDocumentTitle title={title} />;
};

const DocumentTitle = memo(({ title, titleKey }) => {
    if (titleKey) {
        return <TranslatedWindowTitle titleKey={titleKey} />;
    }

    return <RealDocumentTitle title={title} />;
});

export default DocumentTitle;
